import { Link } from "react-router-dom";
import { useShop } from "@/context/ShopContext";
import { visibleOrdered } from "@/components/CategoryNav";
import { Heart } from "lucide-react";

export default function Footer() {
  const { settings } = useShop() || {};
  const cats = visibleOrdered(settings?.categories);
  return (
    <footer data-testid="site-footer" className="bg-kay-ink text-kay-cream mt-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <p className="font-display text-4xl mb-4">
            KAY <span className="italic text-kay-rosedeep">BEAUTY</span>
          </p>
          <p className="text-white/60 text-sm leading-relaxed max-w-sm">
            Les grandes marques, les petits prix. Des produits authentiques de grandes marques,
            proposés jusqu'à -50 %. Belle, sans exploser ton budget.
          </p>
          {settings?.snapchat && (
            <p className="mt-6 font-mono text-xs tracking-widest uppercase text-kay-rosedeep" data-testid="footer-snapchat">
              Snapchat : {settings.snapchat}
            </p>
          )}
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-white/40 mb-4">Boutique</p>
          <div className="flex flex-col gap-2 text-sm text-white/70">
            <Link to="/boutique" className="hover:text-kay-rosedeep transition-colors">Toute la boutique</Link>
            {cats.map((c) => (
              <Link key={c.slug} to={`/boutique/${c.slug}`} className="hover:text-kay-rosedeep transition-colors">{c.label}</Link>
            ))}
            <Link to="/coming-soon" className="hover:text-kay-rosedeep transition-colors">Coming soon</Link>
          </div>
        </div>
        <div className="md:col-span-4">
          <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-white/40 mb-4">La maison</p>
          <div className="flex flex-col gap-2 text-sm text-white/70">
            <Link to="/a-propos" className="hover:text-kay-rosedeep transition-colors">À propos</Link>
            <Link to="/idees" className="hover:text-kay-rosedeep transition-colors">Proposer une idée</Link>
            <Link to="/compte" className="hover:text-kay-rosedeep transition-colors">Mon compte & fidélité</Link>
            <Link to="/panier" className="hover:text-kay-rosedeep transition-colors">Panier</Link>
          </div>
          <p className="mt-6 text-xs text-white/40">Paiement : PayPal · Virement bancaire</p>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-white/40 flex items-center justify-center gap-2">
        © {new Date().getFullYear()} KAY BEAUTY — Fait avec <Heart size={12} className="text-kay-pink" /> et beaucoup de gloss
      </div>
    </footer>
  );
}
